// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@7.1.1_webpack@5.91.0_@swc+core@1.15.18_esbuild@0.20.2_webpack-cli@5.1.4_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@7.1.1_webpack@5.91.0_@swc+core@1.15.18_esbuild@0.20.2_webpack-cli@5.1.4_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.buyerFlow {
  position: relative;
  margin-top: 72px !important;
}

.eventBg {
  position: absolute;
  width: 100%;
  height: 250px;
  top: 0;
  z-index: -1;
  flex: 1 0 0;
  background-size: cover !important;
  background-position: center !important;
}

.eventBg::before {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: auto;
  background-image: inherit;
  background-size: inherit;
  background-position: inherit;
  filter: blur(75px);
  z-index: -1;
}

.eventContainer {
  width: 660px;
  margin: auto;
  margin-top: 36px;
  margin-bottom: 36px;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: flex-start;
  gap: 48px;
  border-radius: 16px;
}

.eventImgContainer {
  height: 322px;
  align-self: stretch;
  border-radius: 16px !important;
  background-size: cover !important;
  background-position: center !important;
}

.eventDescription {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 20px;
  align-self: stretch;
}

.eventHeading {
  font-family: "General Sans";
  font-size: 36px;
  font-style: normal;
  font-weight: 600;
  line-height: 123%;
}

.eventIcon {
  width: 27.429;
  height: 27.429;
}

.eventLocaleContainer {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 12px;
  align-self: stretch;
}

.eventLocale {
  display: flex;
  align-items: center;
  gap: 12px;
}

.ticketContainer {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  align-self: stretch;
}

.bd {
  border-radius: 10.286px;
  border: 0.857px solid var(--Grey-30, #E7E7E7);
  background: var(--White, #FDFDFD);
  box-shadow: 0px 0.857px 1.714px 0px rgba(16, 24, 40, 0.05);
}

.bd_1 {
  border-radius: 12px;
  border: 1px solid var(--Grey-10, #F3F3F3);
  background: var(--White, #FDFDFD);
}

.sell-btn {
  padding: 8px 16px !important;
}

@media screen and (max-width: 650px) {
  .buyerFlow {
    position: relative;
    margin-top: 90px;
  }
  .eventBg {
    position: absolute;
    width: 100%;
    height: 180px;
    top: 0;
    z-index: -1;
    flex: 1 0 0;
    background-size: cover;
    background-position: center;
  }
  .eventBg::before {
    content: "";
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background-image: inherit;
    background-size: inherit;
    background-position: inherit;
    filter: blur(75px);
    z-index: -1;
  }
  .eventContainer {
    padding: 0 24px;
    width: 100%;
    margin: 0;
    margin-top: 40px;
    margin-bottom: 40px;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: flex-start;
    gap: 24px;
    border-radius: 16px;
  }
  .descri {
    gap: 24px !important;
  }
  .eventImgContainer {
    height: 184px !important;
    align-self: stretch;
    border-radius: 16px;
    background-size: cover;
    background-position: center;
  }
  .eventDescription {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 20px;
    align-self: stretch;
  }
  .eventHeading {
    font-size: 24px;
    font-weight: 600;
    line-height: 135%;
  }
  .eventIcon {
    width: 20.571px;
    height: 20.571px;
  }
  .eventLocaleContainer {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
    align-self: stretch;
  }
  .eventLocale {
    display: flex;
    align-items: center;
    gap: 12px;
  }
  .ticketContainer {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
    align-self: stretch;
  }
  .bd {
    border-radius: 10.286px;
    border: 0.857px solid var(--Grey-30, #E7E7E7);
    background: var(--White, #FDFDFD);
    box-shadow: 0px 0.857px 1.714px 0px rgba(16, 24, 40, 0.05);
  }
  .bd_1 {
    border-radius: 12px;
    border: 1px solid var(--Grey-10, #F3F3F3);
    background: var(--White, #FDFDFD);
  }
  .sell-btn {
    padding: 8px 16px !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/routes/buyer-flow/style.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA;EACA,2BAAA;AACJ;;AACA;EACI,kBAAA;EACA,WAAA;EACA,aAAA;EACA,MAAA;EACA,WAAA;EACA,WAAA;EAEA,iCAAA;EACA,sCAAA;AACJ;;AAEA;EACI,WAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,wBAAA;EACA,4BAAA;EACA,kBAAA;EACA,WAAA;AACJ;;AAEA;EACI,YAAA;EACA,YAAA;EACA,gBAAA;EACA,mBAAA;EACA,aAAA;EACA,uBAAA;EACA,sBAAA;EACA,uBAAA;EACA,SAAA;EACA,mBAAA;AACJ;;AAEA;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,iCAAA;EACA,sCAAA;AACJ;;AAEA;EACI,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,SAAA;EACA,mBAAA;AACJ;;AAEA;EACI,2BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AACJ;;AAEA;EACI,aAAA;EACA,cAAA;AACJ;;AAEA;EACI,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,SAAA;EACA,mBAAA;AACJ;;AAEA;EACI,aAAA;EACA,mBAAA;EACA,SAAA;AACJ;;AAEA;EACI,WAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,SAAA;EACA,mBAAA;AACJ;;AAEA;EACI,uBAAA;EACA,6CAAA;EACA,iCAAA;EACA,0DAAA;AACJ;;AAEA;EACI,mBAAA;EACA,yCAAA;EACA,iCAAA;AACJ;;AAEA;EACI,4BAAA;AACJ;;AAEA;EACI;IACI,kBAAA;IACA,gBAAA;EACN;EAEE;IACI,kBAAA;IACA,WAAA;IACA,aAAA;IACA,MAAA;IACA,WAAA;IACA,WAAA;IACA,sBAAA;IACA,2BAAA;EAAN;EAGE;IACI,WAAA;IACA,kBAAA;IACA,OAAA;IACA,MAAA;IACA,WAAA;IACA,YAAA;IACA,yBAAA;IACA,wBAAA;IACA,4BAAA;IACA,kBAAA;IACA,WAAA;EADN;EAIE;IACI,eAAA;IACA,WAAA;IACA,SAAA;IACA,gBAAA;IACA,mBAAA;IACA,aAAA;IACA,uBAAA;IACA,sBAAA;IACA,uBAAA;IACA,SAAA;IACA,mBAAA;EAFN;EAKE;IACI,oBAAA;EAHN;EAME;IACI,wBAAA;IACA,mBAAA;IACA,mBAAA;IACA,sBAAA;IACA,2BAAA;EAJN;EAOE;IACI,aAAA;IACA,sBAAA;IACA,uBAAA;IACA,SAAA;IACA,mBAAA;EALN;EAQE;IACI,eAAA;IACA,gBAAA;IACA,iBAAA;EANN;EASE;IACI,eAAA;IACA,gBAAA;EAPN;EAUE;IACI,aAAA;IACA,sBAAA;IACA,uBAAA;IACA,SAAA;IACA,mBAAA;EARN;EAWE;IACI,aAAA;IACA,mBAAA;IACA,SAAA;EATN;EAYE;IACI,WAAA;IACA,aAAA;IACA,sBAAA;IACA,uBAAA;IACA,SAAA;IACA,mBAAA;EAVN;EAaE;IACI,uBAAA;IACA,6CAAA;IACA,iCAAA;IACA,0DAAA;EAXN;EAcE;IACI,mBAAA;IACA,yCAAA;IACA,iCAAA;EAZN;EAeE;IACI,4BAAA;EAbN;AACF","sourcesContent":[".buyerFlow{\n    position: relative;\n    margin-top: 72px !important;\n}\n.eventBg{\n    position: absolute;\n    width: 100%;\n    height: 250px ;\n    top: 0;\n    z-index: -1;\n    flex: 1 0 0;\n    // background: linear-gradient(180deg, rgba(255, 255, 255, 0.00) 9.25%, rgba(255, 255, 255, 0) 70%, rgba(255, 255, 255, 0.393) 92.13%), url('/assets/images/Image-upload.svg') lightgray 0px -127.411px / 100% 171.591% no-repeat;\n    background-size: cover !important;\n    background-position: center !important;\n}\n\n.eventBg::before{\n    content: '';\n    position: absolute;\n    left: 0;\n    top: 0;\n    width: 100%;\n    height: auto;\n    background-image: inherit;\n    background-size: inherit;\n    background-position: inherit;\n    filter: blur(75px);\n    z-index: -1;\n}\n\n.eventContainer{\n    width: 660px;\n    margin: auto;\n    margin-top: 36px;\n    margin-bottom: 36px;\n    display: flex;\n    justify-content: center;\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 48px;\n    border-radius: 16px;\n}\n\n.eventImgContainer{\n    height: 322px;\n    align-self: stretch;\n    border-radius: 16px !important;\n    background-size: cover !important;\n    background-position: center !important;\n}\n\n.eventDescription{\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 20px;\n    align-self: stretch;\n}\n\n.eventHeading{\n    font-family: \"General Sans\";\n    font-size: 36px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: 123%; \n}\n\n.eventIcon{\n    width: 27.429;\n    height: 27.429;\n}\n\n.eventLocaleContainer{\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 12px;\n    align-self: stretch;\n}\n\n.eventLocale{\n    display: flex;\n    align-items: center;\n    gap: 12px;\n}\n\n.ticketContainer{\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 16px;\n    align-self: stretch;\n}\n\n.bd{\n    border-radius: 10.286px;\n    border: 0.857px solid var(--Grey-30, #E7E7E7);\n    background: var(--White, #FDFDFD);\n    box-shadow: 0px 0.857px 1.714px 0px rgba(16, 24, 40, 0.05);\n}\n\n.bd_1{\n    border-radius: 12px;\n    border: 1px solid var(--Grey-10, #F3F3F3);\n    background: var(--White, #FDFDFD);\n}\n\n.sell-btn{\n    padding: 8px 16px !important;\n}\n\n@media screen and (max-width: 650px) {\n    .buyerFlow{\n        position: relative;\n        margin-top: 90px;\n    }\n\n    .eventBg{\n        position: absolute;\n        width: 100%;\n        height: 180px;\n        top: 0;\n        z-index: -1;\n        flex: 1 0 0;\n        background-size: cover;\n        background-position: center;\n    }\n    \n    .eventBg::before{\n        content: '';\n        position: absolute;\n        left: 0;\n        top: 0;\n        width: 100%;\n        height: 100%;\n        background-image: inherit;\n        background-size: inherit;\n        background-position: inherit;\n        filter: blur(75px);\n        z-index: -1;\n    }\n    \n    .eventContainer{\n        padding: 0 24px;\n        width:100%;\n        margin: 0;\n        margin-top: 40px;\n        margin-bottom: 40px;\n        display: flex;\n        justify-content: center;\n        flex-direction: column;\n        align-items: flex-start;\n        gap: 24px;\n        border-radius: 16px;\n    }\n\n    .descri{\n        gap: 24px !important;\n    }\n    \n    .eventImgContainer{\n        height: 184px !important;\n        align-self: stretch;\n        border-radius: 16px;\n        background-size: cover;\n        background-position: center;\n    }\n    \n    .eventDescription{\n        display: flex;\n        flex-direction: column;\n        align-items: flex-start;\n        gap: 20px;\n        align-self: stretch;\n    }\n    \n    .eventHeading{\n        font-size: 24px;\n        font-weight: 600;\n        line-height: 135%;\n    }\n\n    .eventIcon{\n        width: 20.571px;\n        height: 20.571px;\n    }\n\n    .eventLocaleContainer{\n        display: flex;\n        flex-direction: column;\n        align-items: flex-start;\n        gap: 12px;\n        align-self: stretch;\n    }\n    \n    .eventLocale{\n        display: flex;\n        align-items: center;\n        gap: 12px;\n    }\n    \n    .ticketContainer{\n        width: 100%;\n        display: flex;\n        flex-direction: column;\n        align-items: flex-start;\n        gap: 16px;\n        align-self: stretch;\n    }\n    \n    .bd{\n        border-radius: 10.286px;\n        border: 0.857px solid var(--Grey-30, #E7E7E7);\n        background: var(--White, #FDFDFD);\n        box-shadow: 0px 0.857px 1.714px 0px rgba(16, 24, 40, 0.05);\n    }\n    \n    .bd_1{\n        border-radius: 12px;\n        border: 1px solid var(--Grey-10, #F3F3F3);\n        background: var(--White, #FDFDFD);\n    }\n    \n    .sell-btn{\n        padding: 8px 16px !important;\n    }\n    \n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
